import Chip, { ChipProps, Variant } from './Chip'
import NewChip, { NewChipProps } from './NewChip'

export type { ChipProps, NewChipProps, Variant }

export default {
  Chip,
  NewChip,
}
